export default __webpack_public_path__ + "static/media/ls1.679c5929.jpg";